import { AccessDecision } from '../Types/access-decision.type';

export const ACCESS_DECISION_DENIED_MESSAGE = 'shared.api.errors.access_decision_denied';

export const REQUEST_ACCESS_ROUTE = '/request-access';

export const BILLING_ROUTE = '/settings/billing';

export const ACCESS_DECISION_ROUTES: Partial<Record<AccessDecision, string>> = {
    request_access_required: REQUEST_ACCESS_ROUTE,
    subscription_action_required: BILLING_ROUTE,
};
